import React, { useState } from 'react';
import "../assets/gallery.css";
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { LazyLoadImage } from "react-lazy-load-image-component";

const imageContext = require.context('../assets/gallery', false);
const imageFileNames = imageContext.keys().map(key => key.replace('./', ''));

export default function Gallery() {
  const [modalContent, setModalContent] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleImageClick = (src) => {
    setModalContent(<LazyLoadImage src={src} className="modal-img" alt="Modal Content" />);
    setIsModalOpen(true);
  };

  const handleVideoClick = (src) => {
    setModalContent(
      <video className="modal-vid" controls>
        <source src={src} type="video/mp4" />
      </video>
    );
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setModalContent(null);
    setIsModalOpen(false);
  };

  return (
    <div>
      <Navbar />
      <h1 className='gallery-title'>AMIMUN Gallery</h1>
      <div id="gallery" className="container-fluid">
        {imageFileNames.map((imageName, index) => (
          <img
            key={index}
            src={imageContext(`./${imageName}`)}
            className="img-responsive"
            alt={`Gallery Image ${index + 1}`}
            onClick={() => handleImageClick(imageContext(`./${imageName}`))}
          />
        ))}
      </div>

      {isModalOpen && (
        <div id="myModal" className="modal fade" role="dialog">
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-body">
                {modalContent}
                <button type="button" className="close" onClick={closeModal}>&times;</button>
              </div>
            </div>
          </div>
        </div>
      )}
      <Footer />
    </div>
  );
}
